import {
  useTooltip as useReakitTooltip,
  TooltipOptions,
  TooltipHTMLProps,
  TooltipProps,
} from 'reakit';
import { createHook, createComponent } from 'reakit-system';
import { useBox } from '../../Box/Box';
import { useText } from '../../Text/Text';

export type { TooltipProps };

export const useTooltip = createHook<TooltipOptions, TooltipHTMLProps>({
  compose: [useReakitTooltip, useBox, useText],
  useOptions(options) {
    return {
      ...options,
      px: 'tooltipPaddingX',
      py: 'tooltipPaddingY',
      bg: 'tooltipBg',
      borderColor: 'tooltipBg',
      borderWidth: 1,
      borderRadius: 'tooltip',
      color: 'white',
      fontSize: 'fs-14',
      textAlign: 'center',
    };
  },
  useProps(options, props) {
    return { ...props, 'aria-hidden': 'true' };
  },
});

export const Tooltip = createComponent({
  as: 'div',
  useHook: useTooltip,
  memo: true,
});
